module.exports = __webpack_public_path__ + "img/five.e1cfaf82.jpg";